export const EVENT_NOTIFICATION_PATH = "EventUserNotification";
